import { ColumnsType } from 'antd/lib/table';
import { FrequencyDates, NewsTabs, SearchKeysNews, WeekDays, WeekDaysBack } from 'shared/enums/news';
import { TDivisionResponse, TOrganizationResponse } from 'app/services/edpApiV1/moderator';
import { TDivisionEmployees } from './types';

export type ICreateNews = {
  id?: number;
  created: string;
  title: string;
  data: string;
  author: TDivisionEmployees;
  isForAllEmployees?: boolean;
  users: TAddUserEmployee[];
  divisions: TDivisionResponse[];
  organizations: TOrganizationResponse[];
  datesToCreate?: string[];
  startDate?: string;
  time?: string;
  retry?: FrequencyDates;
  days?: WeekDays[];
};

export type IPreparedNewsPublicated = {
  id: number;
  created: string;
  title: string;
  data: string;
  fio: string;
};

export type TNewsColumns = ColumnsType<IPreparedNewsPublicated>;

export interface ICreateNewsRequest {
  created: string;
  title: string;
  content: string;
  userIds: number[];
  divisionIds: string[];
  organizationIds: string[];
  retry: string;
  datesToCreate: string[];
  startDate?: string;
  time?: string;
  days?: string[];
}

export interface IUpdateNewsRequest {
  id: number;
  created: string;
  title: string;
  content: string;
  userIds: number[];
  divisionIds: string[];
  organizationIds: string[];
  retry: string;
  datesToCreate: string[];
  startDate?: string;
  time?: string;
  days?: string[];
}

export interface INewsGetResponsePaginated {
  data: INewsGetResponse[];
  pagination: {
    size: number;
    page: number;
    total: number;
  };
}

export interface INewsGetRequestParams {
  size?: number;
  page?: number;
  type?: NewsTabs;
  id?: number;
  [SearchKeysNews.SEARCH_NAME]?: string;
  [SearchKeysNews.SEARCH_TITLE]?: string;
  [SearchKeysNews.SEARCH_ID]?: string;
}

export interface INewsGetResponse {
  id: number;
  created: string;
  title: string;
  content: string;
  status: NewsTabs;
  author: TNewsEmployee;
  users: TNewsEmployeeFromBack[];
  divisions: TDivisionResponse[];
  organizations: TOrganizationResponse[];
  retry: string;
  datesToCreate: string[];
  startDate?: string;
  time: string;
  days: WeekDaysBack[];
  updateDate?: string;
  publicationDate?: string;
}

export type TNewsEmployee = {
  id: number;
  name: string;
  division: string;
  lastName: string;
  position: string;
  middleName: string;
  organization: string;
  organizationId: string;
  personnelNumber: string;
};

export interface ICreateNewsResponse {
  id: number;
}

export type TUpdateStatus = {
  id: number;
  status: NewsTabs;
};

export enum FilterEmployees {
  EMPLOYEE = 'Сотрудник',
  DIVISION = 'Подразделение',
}

export enum NewsUserSearchType {
  FIO = 'ФИО',
  PERSONNEL_NUMBER = 'Табельный номер',
}

export type TAddUserEmployee = {
  key: number;
  id: number;
  fio: string;
  division: string;
};

export type TNewsEmployeeFromBack = {
  division: string;
  id: number;
  lastName: string;
  middleName: string;
  name: string;
  organization: string;
  organizationId: string;
  personnelNumber: string;
  position: string;
};

export type TNewsEmployeeToSearch = {
  id: number;
  name: string;
  lastName: string;
  personnelNumber: string;
  middleName: string;
  image: {
    id: 0;
    filename: string;
    path: string;
    uri: string;
  };
  division: {
    id: string;
    code: string;
    name: string;
    validFrom: string;
    validTo: string;
  };
  position: {
    id: string;
    name: string;
    validFrom: string;
    validTo: string;
  };
  temporaryPassword: string;
};

export type TSearchData = {
  key: SearchKeysNews;
  value: string;
};

export type TPrepareNewsToSaveData = {
  retry: FrequencyDates;
  time: string | undefined | null;
  startDate: string | undefined;
  datesToCreate: string[];
  days: WeekDays[];
};
